import React from 'react';
import { observer } from 'mobx-react';

import { constants } from '../../../config';
import { ScreenStore } from '../../../stores/ScreenStore';
import { HomeNavbar } from '../../../common/home-navbar';
import { SessionStore } from '../../../stores/SessionStore';
import { BillingStore } from '../../../stores/BillingStore';
import { USER_TYPES } from '../../../models/User';
import { AppRedirect, routeNaming, AppLink } from '../../../routes';
import { MyAccountMenu } from '../my-account-menu';
import { Footer } from '../../../common/footer';
import { Spinner } from '../../../common/spinner';
import { SecondaryButton } from '../../../common/secondary-button';
import { BillingDataCard } from './billing-data-card';
import { BillingDataForm } from '../../../common/billing-data-form';
import styles from './MyBillingData.css';
import { SEO } from '../../../common/seo';

const SCREENS = {
  SHOW_DATA: 'showData',
  EDIT_DATA: 'editData',
  NEW_DATA: 'newData',
};

class MyBillingData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actualScreen: SCREENS.SHOW_DATA,
      billingItem: null,
    };

    this._handleNewDataClick = this._handleNewDataClick.bind(this);
    this._showBillingData = this._showBillingData.bind(this);
    this._handleEditClick = this._handleEditClick.bind(this);
    this._toggleCancel = this._toggleCancel.bind(this);
  }

  componentDidMount() {
    BillingStore.getBillingData();
  }

  componentWillUnmount() {
    BillingStore.clearGetDataError();
  }

  _handleNewDataClick(event) {
    event.preventDefault();
    this.setState({
      actualScreen: SCREENS.NEW_DATA,
    });
  }

  _showBillingData() {
    this.setState({
      actualScreen: SCREENS.SHOW_DATA,
      billingItem: null,
    });
  }

  _handleEditClick(billing) {
    this.setState({
      actualScreen: SCREENS.EDIT_DATA,
      billingItem: billing,
    });
  }

  _toggleCancel(event) {
    event.preventDefault();
    this.setState({
      actualScreen: SCREENS.SHOW_DATA,
      billingItem: null,
    });
  }

  render() {
    if (!SessionStore.loggedIn) {
      return (
        <AppRedirect routeName={routeNaming.HOME} />
      );
    }
    const dataLoaded = BillingStore.billingData !== null;
    const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
    const isShowingData = this.state.actualScreen === SCREENS.SHOW_DATA;
    const isEditingData = this.state.actualScreen === SCREENS.EDIT_DATA;
    const isCreatingData = this.state.actualScreen === SCREENS.NEW_DATA;
    return (
      <div className={styles.container}>
        <SEO
          title="Mis datos de facturación"
          type="website"
        />
        <HomeNavbar />
        <div className={styles.mainContent}>
          {
            !mobileVersion &&
            <div className={styles.titleContainer}>
              <h1 className={styles.title}>Mi Cuenta</h1>
              <h2 className={styles.subtitle}>
                <span>Hola, </span>
                {SessionStore.user.type === USER_TYPES.COMPANY ?
                  SessionStore.user.fictitiousName :
                  SessionStore.user.names}
                !
              </h2>
            </div>
          }
          {
            mobileVersion &&
            <p className={styles.breadcrumb}>
              <AppLink
                className={styles.breadcrumb}
                routeName={routeNaming.MY_ACCOUNT_MENU_MOBILE}
              >
                Mi Cuenta
              </AppLink>
              <span> &gt; Mis datos de facturación</span>
            </p>
          }
          <div className={styles.content}>
            {
              !mobileVersion && <MyAccountMenu indexSelectedItem={3} />
            }
            <div className={styles.bodyContainer}>
              <div className={styles.headerContainer}>
                <h2 className={styles.header}>
                  { isShowingData && 'Mis datos de facturación' }
                  { isEditingData && 'Editar datos de facturación' }
                  { isCreatingData && 'Nuevos datos de facturación' }
                </h2>
                {
                  !isShowingData &&
                  <button className={styles.cancelButton} onClick={this._toggleCancel}>
                    CANCELAR
                  </button>
                }
              </div>
              <div className={styles.billingDataContainer}>
                <div className={styles.billingDataContent}>
                  {
                    isCreatingData &&
                    <BillingDataForm
                      buttonText="Crear"
                      onSubmit={this._showBillingData}
                    />
                  }
                  {
                    isShowingData && dataLoaded &&
                    BillingStore.billingData.map(billingItem => (
                      <BillingDataCard
                        key={billingItem.id}
                        billing={billingItem}
                        toogleEditClick={this._handleEditClick}
                      />
                      ))
                  }
                  {
                    isShowingData && !dataLoaded &&
                    <Spinner className={styles.spinner} />
                  }
                  {
                    isEditingData &&
                    <BillingDataForm
                      billing={this.state.billingItem}
                      buttonText="Guardar Cambios"
                      onSubmit={this._showBillingData}
                      onDeletion={this._showBillingData}
                    />
                  }
                </div>
                {
                  isShowingData && dataLoaded &&
                  <SecondaryButton
                    className={styles.newBillingData}
                    onClick={this._handleNewDataClick}
                  >
                    Nueva
                  </SecondaryButton>
                }
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const ObservedMyBillingData = observer(MyBillingData);

export { ObservedMyBillingData as MyBillingData };



// WEBPACK FOOTER //
// ./src/pages/my-account/my-billing-data/MyBillingData.jsx